<template>
  <table class="striped">
    <thead>
      <th><i @click="clearSelection" title="Clear Selection" style="cursor: pointer" class="material-icons">clear</i></th>
      <th>Census Area</th>
      <th>Data Category</th>
      <th>Data Availability</th>
    </thead>
    <tbody>
      <tr v-for="censusArea in CensusAreasForSelect">
        <td><input :id="'ca_' + censusArea.id" type="checkbox" class="filled-in" :checked="CensusAreaChecked(censusArea.id)" @click=checkboxClick(censusArea.id)><label :for="'ca_' + censusArea.id"></label></td>
        <td>{{ censusArea.name }}</td>
        <td class="center_cell">{{ selectedMetricCategory.display.split(' ')[0] }}</td>
        <td class="center_cell"><data-availability-indicator :score="censusArea.score"></data-availability-indicator></td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import DataAvailabilityIndicator from './DataAvailabilityIndicator.vue'
export default {
  name: 'censusarea-list',
  computed: {
    ...mapState([
      'selectedMetricCategory'
    ]),
    ...mapGetters([
      'CensusAreasForSelect',
      'CensusAreaChecked'
    ])
  },
  methods: {
    checkboxClick: function (id) {
      this.$store.commit({
        type: 'censusAreaSelection',
        censusAreaID: id,
        selected: !this.CensusAreaChecked(id)
      })

      this.$store.dispatch('getMetricsForCensusArea', id)
    },
    clearSelection: function () {
      this.$store.commit({
        type: 'clearSelectedCommunities'
      })
    },
  },
  components: {
    DataAvailabilityIndicator
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// CensusAreaList.vue?9b5d1d7a